import React from "react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="w-9 h-9 rounded-xl glass-card flex items-center justify-center
                 text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-100
                 transition-all duration-300"
      aria-label={theme === "dark" ? "Mode clair" : "Mode sombre"}
    >
      {theme === "dark" ? (
        <i className="fa-solid fa-sun text-sm" />
      ) : (
        <i className="fa-solid fa-moon text-sm" />
      )}
    </button>
  );
}
